import { api } from "@/comn";
import { ptlEnvs } from "@/tra/tancis/ptli/comn";
import { TFormSchema, TGridSchema, useFetch } from "@/comn/hooks";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { PTLI0421001Q } from "../PTLI0421001Q";

/*
 * Survey Response Management Service
 * !== 설문 응답 관리 서비스 ==!
 */

/*
 * @ BASE
 * @ 서비스에서 사용하는 기본 정보 세팅
 * @ path : 화면들의 기본 웹 경로
 * @ api : 사용하는 api 의 기본 주소
 * @ api 주소가 여러개일 경우 _ 로구분하여 의미에 맞게 카멜표기업으로 표시 : api_clr
 * @ nodes : 화면의 Page.Navigation 에서 사용하는 기본 결로 Array
 */

export const BASE = {
    path: `${ptlEnvs.base}/surv/rspn`,
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/surv/rspn`,
    nodes: [],
};

/*
 * @ URLS
 * @ 화면에서 사용하는 주소들 정의
 * @ 해당화면의 컴포넌트명 대문자로 정의
 */
export const URLS = {
    ptli0421001q: `${BASE.path}/ptli0421001q`,
    ptli0421002q: `${BASE.path}/ptli0421002q`,
};

/*
 * @ APIS
 * @ 화면에서 사용하는 api 정의
 */
export const APIS = {
    // View my to-do list !== 나의 할일 목록 조회 ==!
    getSurvRspnList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    getSurvRspnInfo: (quesRspnUsrId: any) => {
        return api.get(`${BASE.api}/${quesRspnUsrId}`);
    },

    getSurvDtl: (qestnrId: string) =>
        api.get(`${process.env.REACT_APP_API_PTLI}/api/v1/ptli/intptl/mypage/surv/${qestnrId}`),

    getSurvRspnRslt: (quesRspnUsrId: any) => api.get(`${BASE.api}/result/${quesRspnUsrId}`),
};

export const SF_SURV_RSPN_LIST_SRCH: TFormSchema = {
    id: "form_SurvRspnListSrch",
    schema: {
        bsopClsfCd: { type: "select", label: "L_BSOP_CLSF_CD", all: true, area: "comnCd", comnCd: "COM0024" },
        ptlTpCd: {
            type: "select",
            label: "L_PTL_TP_CD",
            area: "comnCd",
            comnCd: "COM0052",
            excludes: ["B"],
            editType: "both",
        },
        qustnrTtle: { type: "text", label: "L_QUSTNR_TTLE" },
        quesCn: { type: "text", label: "L_QUES_CN" },
        itmCn: { type: "text", label: "L_ITM_CN" },
        rgsrUsr: { type: "text", label: "L_RGSR_USR" },
        cstmSctnOrgzCd: { type: "code", label: "L_CSTM_SCTN", area: "cstmOrgzCd" },
        cstmUnitOrgzCd: { type: "code", label: "L_CSTM_UNIT", area: "cstmOrgzCd" },
    },
};

export const SF_SURV_RSPN_INFO: TFormSchema = {
    id: "form_SurvRspnInfo",
    schema: {
        qestnrId: { type: "text" },
        qustnrTtle: { type: "text", label: "L_ORG_NM" },
        rgsrUsr: { type: "text", label: "L_RGSR_USR" },
        //========================== INTERNAL ============================//

        usrNm: { type: "text", label: "L_USR_NM" },
        usrDmnId: { type: "text", label: "L_USR_DMN_ID" },
        cstmSctnOrgzCd: { type: "code", label: "L_CSTM_SCTN", area: "cstmOrgzCd" },
        cstmUnitOrgzCd: { type: "code", label: "L_CSTM_UNIT", area: "cstmOrgzCd" },
        roleNm: { type: "code", label: "L_ROLE_ID", area: "roleCd" },

        cstmOfcrNo: {
            type: "text",
            label: "L_CSTM_OFCR_NO",
        },

        //========================== OGA, EXTERNAL ============================//
        xtrnUsrUuid: { type: "text", label: "L_XTRN_USR_UUID" },
        orgCd: { type: "text", label: "L_ORG_CD", edit: false },
        orgNm: { type: "text", label: "L_ORG_NM", edit: false },
        coNm: { type: "text", label: "L_CO_NM" },
        coTin: { type: "text", label: "L_CO_TIN" },
        qustnrCoTpCd: {
            type: "radio",
            label: "L_QUSTNR_CO_TP_CD",
            area: "comnCd",
            comnCd: "PTL0060",
            controlSize: 10,
        },

        usrTin: { type: "text", label: "L_TIN" },

        //========================== COMMON ============================//

        quesRspnUsrId: { type: "text" },
        bsopClsfCd: { type: "select", label: "L_BSOP_CLSF_CD", all: true, area: "comnCd", comnCd: "COM0024" },
        ptlTpCd: {
            required: true,
            type: "select",
            label: "L_PTL_TP_CD",
            area: "comnCd",
            comnCd: "COM0052",
            excludes: ["B"],
            editType: "both",
        },
        frstRgsrDtm: {
            type: "date",
            label: "L_FRST_RGSR_DTM",
            start: { name: "reqTimeStart" },
            rangeButton: 4,
        },

        sysmUseFreqCd: {
            type: "radio",
            label: "L_SYSM_USE_FREQ_CD",
            area: "comnCd",
            comnCd: "PTL0059",
            controlSize: 10,
        },
    },
};

export const SG_SURV_RSPN_LIST: TGridSchema = {
    id: "grid_SurvRspnList",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_BSOP_CLSF_NM", binding: "bsopClsfCdNm", width: "10%" }], id: "bsopClsfCd" },
        { cells: [{ header: "L_PTL_TP_CD", binding: "ptlTpCdNm", width: "15%" }], id: "ptlTpCd" },
        { cells: [{ header: "L_QUSTNR_TTLE", binding: "qustnrTtle", width: "*" }] },
        { cells: [{ header: "L_USR_NM", binding: "usrNm", width: "*" }] },
        { cells: [{ header: "L_FRST_RGSR_DTM", binding: "frstRgsrDtm", width: "15%" }] },
    ],
    body: [
        { cells: [{ binding: "bsopClsfCdNm", align: "center" }] },
        { cells: [{ binding: "ptlTpCdNm", align: "center" }] },
        { cells: [{ binding: "qustnrTtle", align: "left" }] },
        { cells: [{ binding: "usrNm", align: "center" }] },
        { cells: [{ binding: "frstRgsrDtm", type: "datetime" }] },
    ],
};
